import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  resultCedula: [],
  //currentCedula: {},
  dataNotFound: [],
  newParte:[],
  resultParte:[],
};
export const mutations = {
  RESULT_CEDULAS({ context }, result_cedulas) {
    state.loading = false;
    // state.resultCedula = Object.assign({}, result_cedulas);
    if (result_cedulas) {
      let cedulas = [];
      Object.entries(result_cedulas).forEach(([key, val]) => cedulas.push(val));
      return (state.resultCedula = cedulas);
    }
  },
  DATA_NOT_FOUND({ context }, data) {
    state.dataNotFound = data
  },
  // SHOW_A_CEDULA({ context }, data) {
  //   state.loading = false;
  //   state.currentCedula = Object.assign({}, data);
  // },
  // RESULT_PARTES({ context }, result_partes) {
  //   state.loading = false;
  //   if (result_partes) {
  //     let partes = [];
  //     Object.entries(result_partes).forEach(([key, val]) => partes.push(val));
  //     return (state.resultParte = partes);
  //   }
  // },
  SAVE_PARTES_C({ context }, parte) {
    state.newParte= Object.assign({}, parte);
  },
  EDIT_PARTE_C({ context }, dataParte) {
    state.dataParte = Object.assign({}, dataParte);
  },
  GET_TOKEN_C({ context }, user) {
    state.token= Object.assign({}, user);
  },
};
export const actions = {
  CONSULTAR_CEDULAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      //console.log(data);
      ApiService.consultarCedula(data)
        .then(response => {
          if (response.data.msg == 'No Data') {
            commit("DATA_NOT_FOUND", data);
          }
          commit("SET_LOADING", false);
          commit("RESULT_CEDULAS", response.data.data.cedulas);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  // SHOW_CEDULA({ commit }, id) {
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.mostrarCedula(id)
  //       .then(response => {
  //         let cedula = response.data.cedula
  //         commit("SET_LOADING", false);
  //         commit("SHOW_A_CEDULA", cedula)
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },

  SAVE_PARTES_C({ commit }, parte) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.addParte(parte)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_PARTES_C", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_PARTE_C({ commit }, dataParte) { //axios, mandar parametros para post
    //console.log("store",role);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.editParte(dataParte)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_PARTE_C", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  // DELETE_PARTE({ commit }, id) { //axios, mandar parametros para post
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.deleteParte(id)//funcion de ApiService
  //       .then(response => {
  //         //console.log("store",response);
  //         commit("SET_LOADING", false);
  //         commit("DELETE_PARTE", response);//mandar a mutations
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },
  GET_TOKEN_C({ commit }, user) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getTokenCedula(user)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOKEN_C", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};
export const getters = {
  listCedulas: state => state.resultCedula,
  //currentCedula: state => state.currentCedula,
  dataNotFound: state => state.dataNotFound,
  listPartes: state => state.resultParte,
  newParte: state => state.newParte,
};
